import React, { useContext, useEffect, useState } from 'react'
import TimeLine from '../../../Base/Components/TimeLine/TimeLine'
import { getMasterWipPlanner, getMasterWipPlannerOrder } from '../../../API/Planning/MasterWip/MasterWipRequest';
import { formatNumberDecimal } from '../../../Base/Services/FormatTemplate';
import SalesOrdersCRUD from '../../Ventas/SalesOrders/SalesOrdersCRUD';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StyleCategoryIcon from '../../../Base/Components/Icon/StyleCategoryIcon';

import './PlanerTimeLine.scss'
import { Tooltip } from 'primereact/tooltip';
import { Checkbox } from 'primereact/checkbox';
import { changeWebConfig } from '../../../Base/API/Users/UserRequests';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

const PlannerMasterWipScreen = () => {

    const { userAuth } = useContext(AuthContext);
    const { config, setTimeLinePlanning } = useContext(ConfigContext)

    const [data, setData] = useState([]);
    const [dates, setDates] = useState([new Date('01/01/2024'), new Date('12/31/2025')]);
    const [showDialogSalesOrder, setShowDialogSalesOrder] = useState(false)
    const [salesOrderEdit, setSalesOrderEdit] = useState(null);
    const [loading, setLoading] = useState(false);


    const milisecondsInADay = 1000 * 60 * 60 * 24;


    const getInfo = async () => {
        setData([]);
        setLoading(true);
        const info = await getMasterWipPlanner();
        const data = info.map((item) => {
            let startDate = new Date(item?.CreateDateWeb);
            let endDate = new Date(item?.PlanExportDateWeb);
            // let startDate = new Date('01/27/2024 00:00:00');
            // let endDate = new Date('01/30/2024 00:00:00');
            let start = new Date(startDate.getTime());
            let end = new Date(endDate.getTime());
            let noDays = ((end.getTime() - start.getTime()) / milisecondsInADay) + 1;

            return {
                ...item,
                start: start,
                end: end,
                startTime: startDate.getTime(),
                endTime: endDate.getTime(),
                noDays: noDays,
                children: [],
                ContentNumber: item?.Cantidad,
                Title: item?.SalesOrder + ' - ' + item?.CustomerName,
                TitleBar: item?.SalesOrder,
                Id: item?.IdSalesOrder,
            }
        })
        // setData(data);
        sortFunction({ dataNew: data, direccion: config.timeLinePlanning.sortDirection });
        setLoading(false);
    }

    const getDetails = async (IdSalesOrder, setDetail) => {
        const info = await getMasterWipPlannerOrder(IdSalesOrder);
        const data = info.map((item) => {
            let startDate = new Date(item?.CreateDateWeb);
            let endDate = new Date(item?.PlanExportDateWeb);
            let start = new Date(startDate.getTime());
            let end = new Date(endDate.getTime());
            let noDays = ((end.getTime() - start.getTime()) / milisecondsInADay) + 1;

            return {
                ...item,
                child: 1,
                start: start,
                end: end,
                startTime: startDate.getTime(),
                endTime: endDate.getTime(),
                noDays: noDays,
                children: [],
                Id: item?.IdSalesOrder + '-' + item?.IdSalesOrderDetail,
                Title: item?.ColorName + '-' + item?.IdSalesOrderDetail
            }
        })
        setDetail(data);
    }

    const toolTipItem = (Item) => {
        let unit = (Item?.UnitSimbol + 'S').toUpperCase()

        return (
            <div className='col-12 toolTipItem' style={{ justifyContent: 'space-between', width: 300, }}>
                <div className='d-flex col-12 gap' style={{ alignItems: 'center' }}>
                    <div className='col-1' style={{ color: '#FFF' }} >
                        <StyleCategoryIcon
                            StyleCategory={Item?.StyleCategory}
                            color={'#FFFFFF'}
                        />
                    </div>
                    <div className='nowrap'>{Item.SalesOrder}</div>
                    <div className=''>
                        {Item?.ContentNumber && <div className='nowrap content'>( {Item.ContentNumber} )</div>}
                    </div>
                </div>
                <div>
                    <div className='nowrap fs-5'>{Item?.CustomerName}</div>
                </div>
                {Item?.ColorName && <div >
                    <div className='nowrap fs-5'><span className='fw-bold'>Color: </span>{Item?.ColorName}</div>
                </div>}
                {Item?.StyleName && <div className='border-bottom'>
                    <div className='fs-5 nowrap'><span className='fw-bold'>Style: </span> {Item?.StyleName}</div>
                </div>}


                <div className='border-top'>
                    {/* {Item?.KgsQty && <div className='nowrap content'>Kg: {formatNumberDecimal(Item?.KgsQty)} Kg</div>} */}
                    <div className='d-flex fs-5 center' >
                        <div className='nowrap content text-center '>Ordenado</div>
                    </div>
                </div>
                <div >
                    {/* {Item?.KgsQty && <div className='nowrap content'>Kg: {formatNumberDecimal(Item?.KgsQty)} Kg</div>} */}
                    <div className='d-flex fs-5' style={{ justifyContent: 'space-between' }} >
                        <div className='nowrap content '>{formatNumberDecimal(Item?.KgsAcabado)} KG</div>
                        <div className='nowrap content text-end '>{formatNumberDecimal(Item?.IdUnit === 2 ? Item?.LbsQtyWL : Item?.YdsAcabado)} {Item?.IdUnit === 2 ? 'Lbs' : 'Yds'} </div>
                    </div>
                </div>
                <div className='border-top'>
                    {/* {Item?.KgsQty && <div className='nowrap content'>Kg: {formatNumberDecimal(Item?.KgsQty)} Kg</div>} */}
                    <div className='d-flex fs-5 center' >
                        <div className='nowrap content text-center '>Exportado</div>
                    </div>
                </div>
                <div >
                    {/* {Item?.KgsQty && <div className='nowrap content'>Kg: {formatNumberDecimal(Item?.KgsQty)} Kg</div>} */}
                    <div className='d-flex fs-5' style={{ justifyContent: 'space-between' }} >
                        <div className='nowrap content '>{formatNumberDecimal(Item?.ExPercent)} %</div>
                        <div className='nowrap content text-end '>{formatNumberDecimal(Item?.Export)} {unit}</div>
                    </div>
                </div>
                {Item?.IdSalesOrderDetail && <div >
                    <div className='d-flex fs-5' style={{ justifyContent: 'space-between', alignItems: 'center' }} >
                        <div className='nowrap content '>Ventas <Checkbox checked={Item?.CerradoVentas} /></div>
                        <div className='nowrap content text-end '><Checkbox checked={Item?.CerradoPlanning} /> Planning</div>
                    </div>
                </div>}
                <div className='col-12 mt-2'>
                    <div className='d-flex border-bottom  border-top' style={{ justifyContent: 'space-between' }} >
                        <div className='nowrap content  Title'>On Time</div>
                        <div className='nowrap content text-end Title'>Past Due</div>
                    </div>
                    <div className='d-flex' style={{ justifyContent: 'space-between' }} >
                        <div className='nowrap content OT-Text'>{formatNumberDecimal(Item?.OT)} {unit}</div>
                        <div className='nowrap content text-danger PD-Text'>{formatNumberDecimal(Item?.PD)} {unit}</div>
                    </div>
                    <div className='d-flex' style={{ justifyContent: 'space-between' }} >
                        <div className='nowrap content  OT-Text'>{formatNumberDecimal(Item?.POT)} %</div>
                        <div className='nowrap content text-danger PD-Text'>{formatNumberDecimal(Item?.PPD)} %</div>
                    </div>
                    <div className='d-flex'>
                        <div className='OT' style={{ width: Item?.POT + '%' }}></div>
                        <div className='PD ' style={{ width: Item?.PPD + '%' }}></div>
                    </div>
                </div>
            </div>
        )
    }

    const bodyItemContent = (Item) => {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <Tooltip target={`#${'A' + Item?.Id}`}>
                    {toolTipItem(Item)}
                </Tooltip>
                <div id={'A' + Item?.Id} className='d-flex gap' style={{ justifyContent: 'space-between', width: '100%', position: 'relative', height: '100%' }}>
                    <div className='d-flex barItem'>
                        <div className='OT' style={{ width: Item?.POT + '%' }}></div>
                        <div className='PD text-end' style={{ width: Item?.PPD + '%' }}></div>
                    </div>
                    <div
                        className='nowrap px-1'

                    >
                        {Item.TitleBar ? Item.TitleBar : Item.Title}
                    </div>
                    <div>

                    </div>
                    {Item?.KgsAcabado && <div className='nowrap' style={{ color: '#FFFFFFCC' }}>{formatNumberDecimal(Item?.KgsAcabado)} Kg  </div>}
                </div>

            </div>
        )
    }

    const titleItem = (Item) => {
        return (
            <div className='col-12 d-flex ' style={{ justifyContent: 'space-between' }}>
                <div className='col-1' style={{ color: '#FFF' }} >
                    <StyleCategoryIcon
                        StyleCategory={Item?.StyleCategory}
                        color={'#FFFFFF'}
                    />
                    {/* <FontAwesomeIcon icon="fa-solid fa-circle-user" />
                // < */}
                    {/* <FontAwesomeIcon icon="fa-brands fa-cotton-bureau" /> */}
                    {/* {Item?.KgsQty && <div className='nowrap' style={{ color: '#FFFFFFCC' }}>{(Item?.StyleCategory === 'Cotton' ? 'C' : 'S')}</div>} */}
                </div>
                <div
                    onDoubleClick={e => {
                        setSalesOrderEdit(Item);
                        setShowDialogSalesOrder(true);
                        e.stopPropagation();
                    }}
                    className='nowrap col-9'>
                    {Item.Title}
                </div>
                <div className='col-1'>
                    {Item?.ContentNumber && <div className='nowrap content'>( {Item.ContentNumber} )</div>}
                </div>
            </div>
        )
    }

    const filterMethod = (item, filter) => {
        if (filter?.length > 0) {
            let filterItem = filter.find(e => e === item?.SalesOrder);
            if (filterItem) {
                return true;
            }
            return false;
        }
        return true;
    }


    const guardarTimeLineConfig = async () => {
        const a = await changeWebConfig(userAuth.idUser, config);
    }

    const changeSortDirection = () => {
        console.log(config.timeLinePlanning.sortDirection);
        let direccion = config.timeLinePlanning.sortDirection === 'desc' ? 'asc' : 'desc';
        setTimeLinePlanning(
            {
                ...config.timeLinePlanning,
                sortDirection: direccion
            }
        );
        sortFunction({ direccion });
    }

    const changeSortBy = (sortBy) => {
        setTimeLinePlanning(
            {
                ...config.timeLinePlanning,
                sortBy: sortBy
            }
        );
        sortFunction({ sortBy, direccion: config.timeLinePlanning.sortDirection });
    }

    const sortFunction = ({ dataNew, direccion = config.timeLinePlanning?.sortDirection, sortBy = config.timeLinePlanning?.sortBy }) => {
        if (sortBy === 'endTime') {
            const a = dataNew ? dataNew : data
            let dataSort = [...a].sort((a, b) => {
                if (direccion === 'asc') {
                    return a.endTime - b.endTime;
                } else {
                    return b.endTime - a.endTime;
                }
            }
            );
            setData(dataSort);
        }
        if (sortBy === 'startTime') {
            const a = dataNew ? dataNew : data
            let dataSort = [...a].sort((a, b) => {
                if (direccion === 'asc') {
                    return a.startTime - b.startTime;
                } else {
                    return b.startTime - a.startTime;
                }
            }
            );
            setData(dataSort);
        }
    }

    const shortSplitButton = [
        {
            label: 'Fecha Inicio',
            icon: 'pi pi-fw pi-calendar',
            command: () => {
                changeSortBy('startTime');
            }
        },
        {
            label: 'Fecha Fin',
            icon: 'pi pi-fw pi-calendar',
            command: () => {
                changeSortBy('endTime');
            }
        },
    ]


    // useEffect(() => {
    //     sortFunction();
    // }, [data])


    useEffect(() => {
        guardarTimeLineConfig();
    }, [config.timeLinePlanning])

    useEffect(() => {
        let configTimeLine = {
            dayWidth: config.timeLinePlanning.dayWidth ? config.timeLinePlanning.dayWidth : 10,
            showDays: config.timeLinePlanning.showDays ? config.timeLinePlanning.showDays : false,
            showWeeks: config.timeLinePlanning.showWeeks ? config.timeLinePlanning.showWeeks : true,
            showMonths: config.timeLinePlanning.showMonths ? config.timeLinePlanning.showMonths : true,
            dividerPosition: config.timeLinePlanning.dividerPosition ? config.timeLinePlanning.dividerPosition : 300,
            sortBy: config.timeLinePlanning.sortBy ? config.timeLinePlanning.sortBy : 'endTime',
            sortDirection: config.timeLinePlanning.sortDirection ? config.timeLinePlanning.sortDirection : 'desc',
            showOptions: config.timeLinePlanning.showOptions ? config.timeLinePlanning.showOptions : false,
            IdItem: config.timeLinePlanning.IdItem ? config.timeLinePlanning.IdItem : "IdSalesOrder"
        }
        guardarTimeLineConfig();
        setTimeLinePlanning(configTimeLine);
        getInfo();
    }, [])

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <TimeLine
                data={data}
                dates={dates}
                setDates={setDates}
                getDetails={getDetails}
                titleItem={titleItem}
                childTitleItem={titleItem}
                bodyItemContent={bodyItemContent}
                childBodyItemContent={bodyItemContent}
                filterMethod={filterMethod}
                getInfo={getInfo}
                loading={loading}
                timeLineConfig={config.timeLinePlanning}
                setTimeLineConfig={setTimeLinePlanning}
                chageSortDirection={changeSortDirection}
                shortSplitButton={shortSplitButton}

            />
            <SalesOrdersCRUD
                dialogSO={showDialogSalesOrder}
                hideDialog={() => setShowDialogSalesOrder(false)}
                IdSalesOrder={salesOrderEdit?.IdSalesOrder}
            />
        </div>
    )
}

export default PlannerMasterWipScreen